import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

import Select from './select';
import EditPanel from './edit-panel';

class CreateTaskButton extends PureComponent {
    static contextType = RolesAndPermissionsContext;

    state = {
        createTaskVisible: false,
        selectedProject: null
    }

    handleProjectChange = ({ id }) => {
        this.setState({
            selectedProject: id
        });
    }


    handleCreateTaskClick = () => {
        this.setState({
            createTaskVisible: true
        });
    }

    handleCreateTaskSubmit = name => {
        if (this.props.showProjectSelect && !this.state.selectedProject) {
            return;
        }

        this.props.onCreateTask && this.props.onCreateTask(name, this.state.selectedProject);

        this.setState({
            createTaskVisible: false
        });
    }

    handleCreateTaskCancel = () => {
        this.setState({
            createTaskVisible: false
        });
    }

    render() {
        if (!this.context?.canUser('createTask')) {
            return null
        }

        const { t } = this.props;

        if (this.state.createTaskVisible) {
            return (
                <React.Fragment>
                    {
                        this.props.showProjectSelect ? (
                            <Select
                                placeholder={ t('project:Select a project') }
                                options={this.props.projects.map(project => ({ id: project.id, text: project.name }))}
                                onChange={this.handleProjectChange}
                            />
                        ) : null
                    }

                    <EditPanel
                        placeholder={ t('common:Give it a name') }
                        actionText={ t('common:Create') }
                        onSubmit={this.handleCreateTaskSubmit}
                        onCancel={this.handleCreateTaskCancel}
                        noClose={true}
                        autoFocus={true}
                    />
                </React.Fragment>
            );
        }

        return (
            <button onClick={this.handleCreateTaskClick} disabled={this.props.disabled} className="btn btn-medium btn-secondary btn-bordered btn-block btn-colored">
                {
                    this.props.hasTasks ? t('Add a new task') : t('Add a task')
                }
            </button>
        );
    }
}

export default withTranslation(['task', 'common'])(CreateTaskButton);
